export const INCIDENT_ACTIONS = {
  OPEN_INCIDENT: "open-incident",
  CLOSE_INCIDENT: "close-incident",
  SET_INITIAL_CALL_INFO: "set-initial-call-info",
  UPDATE_INCIDENT: "update-incident",
  UPDATE_INCIDENT_WITH_MERGE: "update-incident-with-merge",
  REPLACE_INCIDENT: "replace-incident",
  UPDATE_INCIDENT_ADDRESS_ALERT: "update-incident-address-alert",
  ADD_EMPTY_OIS: "add-empty-ois",
  UPDATE_OIS: "update-ois",
  UPDATE_OIS_FROM_UUID: "update-ois-from-uuid",
  UPDATE_OFFICER_IN_OIS: "update-officer-in-ois",
  REMOVE_OIS: "remove-ois",
  UPDATE_PIS: "update-pis",
  ADD_VIS: "add-vis",
  UPDATE_VIS: "update-vis",
  REMOVE_VIS: "remove-vis",
  UPDATE_VEHICLE: "update-vehicle",
  UPDATE_INCIDENT_DETAIL: "update-incident-detail",
  UPDATE_INCIDENT_DETAIL_NARRATIVE: "update-incident-detail-narrative",
  REMOVE_INCIDENT_DETAIL_NARRATIVE: "remove-incident-detail-narrative",
  ADD_INCIDENT_DETAIL_NARRATIVE: "add-incident-detail-narrative",
  UPDATE_PERSON_IN_PIS: "update-person-in-pis",
  REMOVE_PIS: "remove-pis",
  ADD_PIS: "add-pis",
  MERGE_PIS: "merge-pis",
  ADD_OR_UPDATE_PIS: "add-or-update-pis",
  ADD_OR_UPDATE_VIS: "add-or-update-vis",
  UPDATE_PIS_FROM_UUID: "update-pis-from-uuid",
  ADD_OFFLINE_INCIDENT: "add-offline-incident",
  EXTEND_PIS: "extend-pis",
  UPDATE_PERSON_PERSONAL_ATTRIBUTE_IN_PIS:
    "update-person-personal-attribute-in-pis",
  ADD_OFFENSE: "add-offense",
  REMOVE_OFFENSE: "remove-offense",
  UPDATE_OFFENSE: "update-offense",
  UPDATE_SVA: "update-sva",
  UPDATE_SVA_ALL_INCIDENTS: "update-sva-all-incidents",
  ADD_SVA: "add-sva",
  REMOVE_SVA: "remove-sva",
  ADD_ARREST: "add-arrest",
  REMOVE_ARREST: "remove-arrest",
  UPDATE_ARREST: "update-arrest",
  ADD_CHARGE: "add-charge",
  REMOVE_CHARGE: "remove-charge",
  UPDATE_CHARGE: "update-charge",
  UPDATE_CHARGE_ALL_INCIDENTS: "update-charge-all-incidents",
  ADD_PROPERTY: "add-property",
  REMOVE_PROPERTY: "remove-property",
  UPDATE_PROPERTY: "update-property",
  UPDATE_INCIDENT_TICKET: "update-incident-ticket",
  REMOVE_INCIDENT_TICKET: "remove-incident-ticket",
  ADD_TICKET_TO_INCIDENT: "add-ticket-to-incident",
  ADD_CUSTODY_CHAIN: "add-custody-chain",
  REMOVE_CUSTODY_CHAIN: "remove-custody-chain",
  UPDATE_CUSTODY_CHAIN: "update-custody-chain",
  ADD_LAB_ANALYSIS: "add-lab-analysis",
  REMOVE_LAB_ANALYSIS: "remove-lab-analysis",
  UPDATE_LAB_ANALYSIS: "update-lab-analysis",
  UPDATE_INCIDENT_REVIEW: "update-incident-review",
  ADD_NIC: "add-nic",
  REMOVE_NIC: "remove-nic",
  UPDATE_NIC: "update-nic",
  ADD_INCIDENT_TO_LINK: "add-incident-to-link",
  REMOVE_INCIDENT_FROM_LINK: "remove-incident-from-link",
  UPDATE_QUERY_RETURNS: "update-query-returns",
  SET_NIC_ENTRY: "set-nic-entries",
  UPDATE_OIS_MULTI_FIELD: "update-ois-multi-field",
  SET_DISPATCH_NARRATIVES: "set-dispatch-narratives",
  // ADD_DISPATCH_NARRATIVE: "add-dispatch-narrative",
  // UPDATE_DISPATCH_NARRATIVE: "update-dispatch-narrative",
  REMOVE_DISPATCH_NARRATIVE: "remove-dispatch-narrative",
  ADD_OR_UPDATE_DISPATCH_NARRATIVE: "add-or-update-dispatch-narrative",
};
